import type { ZeytalCLIPureConfig } from "@zeytal/kit";
import type { FigmaRestApi, ZeytalTokens } from "@zeytal/types";

import { fontValToPx, fontValToRem } from "../../../utils/font.ts";

export const fontMaker = (
  stylesFormatsConfig: ZeytalCLIPureConfig["styles"]["formats"],
  fontValues: FigmaRestApi.TypeStyle,
) => {
  const { usePostscriptFontNames, unit, relativeLineHeight } =
    stylesFormatsConfig.fonts;

  const {
    fontPostScriptName,
    fontFamily,
    fontSize,
    letterSpacing,
    lineHeightPx,
    lineHeightPercentFontSize,
    fontWeight,
    italic,
    textCase,
    textDecoration,
  } = fontValues;

  const value = {
    fontName: (usePostscriptFontNames ? fontPostScriptName : fontFamily) ?? "",
    fontSize: fontValToPx(fontSize ?? 0),
    lineHeight: lineHeightPx
      ? fontValToPx(lineHeightPx)
      : fontValToPx(fontSize ?? 0),
    fontWeight: fontWeight ?? 400,
  } as ZeytalTokens.FontStyleValue;

  // Transform font size based on config
  if (fontSize) {
    if (unit === "rem") {
      value.fontSize = fontValToRem(fontSize);
    } else if (unit === "px") {
      value.fontSize = fontValToPx(fontSize);
    }
  }

  // Transform line height based on config
  if (relativeLineHeight && lineHeightPercentFontSize) {
    value.lineHeight = lineHeightPercentFontSize / 100;
  } else if (unit === "rem" && lineHeightPx) {
    value.lineHeight = fontValToRem(lineHeightPx);
  } else if (unit === "px" && lineHeightPx) {
    value.lineHeight = fontValToPx(lineHeightPx);
  }

  // Add letter spacing only if defined
  if (letterSpacing) {
    if (unit === "rem") {
      value.letterSpacing = fontValToRem(letterSpacing);
    } else if (unit === "px") {
      value.letterSpacing = fontValToPx(letterSpacing);
    }
  }

  // Add italic only if defined
  if (italic !== undefined) {
    value.italic = italic;
  }

  // Add text case only if defined
  if (textCase) {
    value.textCase = textCase;
  }

  // Add text decoration only if defined
  if (textDecoration) {
    value.textDecoration = textDecoration;
  }

  return value;
};
